<div class="layout-topbar">
    <div class="topbar-left">
        <a
            #menubutton
            tabindex="0"
            class="menu-button p-trigger"
            (click)="onMenuButtonClick()"
        >
            <i class="pi pi-chevron-left"></i>
        </a>
        <img
            class="horizontal-logo"
            [routerLink]="['/']"
            [src]="'assets/layout/images/logo-' + logo + '.svg'"
            alt="diamond-layout"
        />
        <span class="topbar-separator"></span>
        <app-breadcrumb></app-breadcrumb>
        <img
            width="75"
            height="27"
            src="assets/demo/images/wise-logo.png"
            alt="diamond-layout"
        />
    </div>

    <div class="layout-topbar-menu-section">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-mask modal-in"></div>

    <div class="topbar-right">
        <ul class="topbar-menu">
            <li class="static sm:relative">
                <p-dropdown
                    [options]="languages"
                    (onChange)="languageChanged($event)"
                    [(ngModel)]="selectedLanguage"
                    placeholder="Language"
                    size="small"
                    optionLabel="name"
                    optionValue="value"
                ></p-dropdown>
            </li>
            <li class="static sm:relative">
                <a
                    tabindex="0"
                    enterFromClass="hidden"
                    enterActiveClass="scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="fadeout"
                    [routerLink]="'/home/cart'"
                >
                    <i class="pi pi-shopping-cart"></i>
                    <span class="topbar-badge" *ngIf="peekCartObject">{{
                            peekCartObject.numberOfItems
                        }}</span>
                </a>
            </li>

            <li class="static sm:relative ml-5">
                <a
                    *ngIf="getDeviceType() === 'desktop' || getDeviceType()==='tablet'"
                    tabindex="0"
                    pStyleClass="@next"
                    class="flex w-12rem"
                    enterFromClass="hidden"
                    enterActiveClass="scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-user mr-2"></i>
                    <span class="profile-name font-semibold" *ngIf="userProfile"
                    >{{ userProfile.given_name }}
                        {{ userProfile.family_name }}</span
                    >
                </a>
                <a
                    *ngIf="getDeviceType() === 'mobile'"
                    tabindex="0"
                    pStyleClass="@next"
                    class="flex"
                    enterFromClass="hidden"
                    enterActiveClass="scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-user mr-2"></i>
                    <span class="profile-name font-semibold" *ngIf="userProfile"
                    >{{ userProfile.given_name }}
                        {{ userProfile.family_name }}</span
                    >
                </a>
                <ul
                    class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-12rem mt-2 right-0 z-5 top-auto"
                >
                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                            routerLink="/home/profile/view"
                        >
                            <i class="pi pi-user mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{
                                        "Profile" | translate
                                    }}</span>
                            </span>
                        </a>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                            (click)="onLogout()"
                        >
                            <i class="pi pi-power-off mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{
                                        "Logout" | translate
                                    }}</span>
                            </span>
                        </a>
                    </li>
                </ul>

                <!-- <li class="right-sidebar-item">
                <a tabindex="0" (click)="onRightMenuClick()">
                    <i class="pi pi-align-right"></i>
                </a>
            </li> -->
            </li>
        </ul>
    </div>
</div>
